/**
 * ENVIRONMENT: PRODUCTION
 * COMPONENT: AppSidebar Navigation
 * PATH: src/layout/AppSidebar.js
 * SCOPE: Complete B2C Direct Service Suite
 */

import React, { useState, useEffect } from "react";
import { Layout, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

// images & brand
import logo from "assets/images/logo.png";

// icons
import newOverview from "assets/images/overview.png";
import overviewWhite from "assets/images/whiteIcon/overviewWhite.png";
import categories from "assets/images/categories.png";
import categoriesWhite from "assets/images/categoriesWhite.png";
import newtransaction from "assets/images/transaction.png";
import transactionwWhite from "assets/images/whiteIcon/transactionWhite.png";
import newusericon from "assets/images/usersicon.png";
import usersIcon from "assets/images/Userswhite.png";
import giftvouchericon from "assets/images/gift-card-icon.png";
import giftvoucherWhite from "assets/images/gift-card-icon-white.png";
import complainIcon from "assets/images/complain.png";
import complainWhite from "assets/images/complainWhite.png";
import walletIcon from "assets/images/wallet.png";
import walletWhite from "assets/images/walletWhite.png";
import newpayinpayout from "assets/images/payinpayout.png";
import payinandpayoutWhite from "assets/images/whiteIcon/payinandpayoutWhite.png";

import {
  DeviceMobileIcon,
  CashIcon,
  ArrowRightIcon,
} from "@heroicons/react/outline";
import { HiMenuAlt2 } from "react-icons/hi";

const { Sider } = Layout;

// Production B2C Service Navigation Structure
const menu = [
  {
    title: "Dashboard",
    key: "overviewpayin",
    icon: [
      <img
        key="norm"
        src={newOverview}
        alt="Dashboard"
        width={24}
        height={24}
        className="normalWhite ant-menu-item-icon"
      />,
      <img
        key="active"
        src={overviewWhite}
        alt="Dashboard"
        width={24}
        height={24}
        className="activeWhite ant-menu-item-icon"
      />,
    ],
    path: "/overviewpayin",
  },
  {
    title: "BBPS & NCMC Transit",
    key: "bbps_ncmc",
    icon: [
      <img
        key="norm"
        src={categories}
        alt="BBPS & NCMC"
        width={24}
        height={24}
        className="normalWhite ant-menu-item-icon"
      />,
      <img
        key="active"
        src={categoriesWhite}
        alt="BBPS & NCMC"
        width={24}
        height={24}
        className="activeWhite ant-menu-item-icon"
      />,
    ],
    path: "/billpayments",
  },
  {
    title: "Mobile & DTH Recharge",
    key: "recharges",
    icon: [
      <DeviceMobileIcon key="norm" width={24} height={24} className="normalWhite ant-menu-item-icon" />,
      <DeviceMobileIcon key="active" width={24} height={24} className="activeWhite ant-menu-item-icon" />,
    ],
    path: "/recharges",
  },
  {
    title: "Prepaid Cards",
    key: "prepaid_cards",
    icon: [
      <img
        key="norm"
        src={walletIcon}
        alt="Prepaid Cards"
        width={24}
        height={24}
        className="normalWhite ant-menu-item-icon"
      />,
      <img
        key="active"
        src={walletWhite}
        alt="Prepaid Cards"
        width={24}
        height={24}
        className="activeWhite ant-menu-item-icon"
      />,
    ],
    path: "/prepaid-cards",
  },
  {
    title: "Gift Voucher",
    key: "giftvouchers",
    icon: [
      <img
        key="norm"
        src={giftvouchericon}
        alt="Gift Voucher"
        width={24}
        height={24}
        className="normalWhite ant-menu-item-icon"
      />,
      <img
        key="active"
        src={giftvoucherWhite}
        alt="Gift Voucher"
        width={24}
        height={24}
        className="activeWhite ant-menu-item-icon"
      />,
    ],
    path: "/giftvouchers",
  },
  /* TEMPORARILY DISABLED: Insurance Services
  {
    title: "Insurance Services",
    key: "insurance_services",
    icon: [
      <img
        key="norm"
        src={newpayinpayout}
        alt="Insurance Services"
        width={24}
        height={24}
        className="normalWhite ant-menu-item-icon"
      />,
      <img
        key="active"
        src={payinandpayoutWhite}
        alt="Insurance Services"
        width={24}
        height={24}
        className="activeWhite ant-menu-item-icon"
      />,
    ],
    path: "/insurance",
  },
  */
  /* TEMPORARILY DISABLED: Consumer Loans
  {
    title: "Consumer Loans",
    key: "consumer_loans",
    icon: [
      <CashIcon key="norm" width={24} height={24} className="normalWhite ant-menu-item-icon" />,
      <CashIcon key="active" width={24} height={24} className="activeWhite ant-menu-item-icon" />,
    ],
    path: "/loans",
  },
  */
  {
    title: "Users",
    key: "users",
    icon: [
      <img
        key="norm"
        src={newusericon}
        alt="Users"
        width={24}
        height={24}
        className="normalWhite ant-menu-item-icon"
      />,
      <img
        key="active"
        src={usersIcon}
        alt="Users"
        width={24}
        height={24}
        className="activeWhite ant-menu-item-icon"
      />,
    ],
    path: "/users",
  },
  {
    title: "Transaction",
    key: "transaction",
    icon: [
      <img
        key="norm"
        src={newtransaction}
        alt="Transaction"
        width={24}
        height={24}
        className="normalWhite ant-menu-item-icon"
      />,
      <img
        key="active"
        src={transactionwWhite}
        alt="Transaction"
        width={24}
        height={24}
        className="activeWhite ant-menu-item-icon"
      />,
    ],
    path: "/transaction",
  },
  {
    title: "Complaint List",
    key: "complaints",
    icon: [
      <img
        key="norm"
        src={complainIcon}
        alt="Complaint List"
        width={24}
        height={24}
        className="normalWhite ant-menu-item-icon"
      />,
      <img
        key="active"
        src={complainWhite}
        alt="Complaint List"
        width={24}
        height={24}
        className="activeWhite ant-menu-item-icon"
      />,
    ],
    path: "/transactionspayin",
  },
];

const AppSidebar = (props) => {
  const { isCollapsed, toggleCollapse } = props;
  const [selectedKeys, setSelectedKeys] = useState(["overviewpayin"]);
  const [openKeys, setOpenKeys] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let childIndex = -1;
    const selectedMenuItem = menu.find((item) => {
      if (item.childrens) {
        const tmp = item.childrens.findIndex(
          (child) => location.pathname === child.path
        );
        if (tmp >= 0) {
          childIndex = tmp;
          return true;
        }
        return false;
      }
      return location.pathname === item.path || location.pathname.startsWith(item.path + "/");
    });

    if (selectedMenuItem) {
      if (selectedMenuItem.childrens) {
        setSelectedKeys([
          selectedMenuItem.key,
          selectedMenuItem.childrens[childIndex].key,
        ]);
        setOpenKeys([selectedMenuItem.key]);
      } else {
        setSelectedKeys([selectedMenuItem.key]);
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isCollapsed) setOpenKeys([]);
  }, [isCollapsed]);

  const onToggleSubMenu = (key) => {
    if (openKeys.includes(key)) {
      setOpenKeys([]);
    } else {
      setOpenKeys([key]);
    }
  };

  return (
    <Sider className="app-sidebar" theme="light" collapsed={isCollapsed}>
      {isCollapsed ? (
        <img src={logo} alt="MTMPAY" className="logo-collapsed mt-8 ml-16" />
      ) : (
        <img src={logo} alt="MTMPAY" className="logo mt-8 ml-24 mr-24" />
      )}
      <Menu
        mode="inline"
        className="sidebar-menu"
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        onClick={({ key }) => setSelectedKeys([key])}
      >
        <Menu.Item
          key={"collapse"}
          icon={
            isCollapsed ? (
              <ArrowRightIcon width={24} height={24} />
            ) : (
              <HiMenuAlt2
                width={24}
                height={24}
                className="humburger"
              />
            )
          }
          onClick={toggleCollapse}
          className="menu-item--collapse toggle"
        >
          {isCollapsed ? "Expand Menu" : "Collapse Menu"}
        </Menu.Item>

        {menu.map((item) => {
          if (item.childrens && item.childrens.length) {
            return (
              <Menu.SubMenu
                key={item.key}
                icon={item.icon}
                title={item.title}
                onTitleClick={() => onToggleSubMenu(item.key)}
              >
                {item.childrens.map((child) => (
                  <Menu.Item
                    key={child.key}
                    icon={child.icon}
                    onClick={() => navigate(child.path)}
                  >
                    {child.title}
                  </Menu.Item>
                ))}
              </Menu.SubMenu>
            );
          }
          return (
            <Menu.Item
              key={item.key}
              icon={item.icon}
              onClick={() => navigate(item.path)}
            >
              {item.title}
            </Menu.Item>
          );
        })}
      </Menu>
    </Sider>
  );
};

export default AppSidebar;